import { palette } from "../globals/palette";

export const divider = {
  MuiDivider: {
    root: {
      backgroundColor: palette.grey[300],
    },
  },
};
